import { firebaseMutations } from 'vuexfire'

const mutations = {
  ...firebaseMutations,

  TOGGLE_MODAL (state) {
    state.showModal = !state.showModal
  },
  SET_SELECTED_ITEM (state, payload) {
    state.selectedItem = payload
  },
  TOGGLE_RANGE (state) {
    state.rangeEdit = !state.rangeEdit
  },
  SET_SELECTED_RANGE (state, payload) {
    state.selectedRange = payload
  }
}

export default mutations
